(function ($) {
    var look = {
        currentIndex: 0,
        lookData: {},
        models: [],
        init: function () {
            var S = this;
            S.maxDom = $('.product-details-look');
            S.handleObserver();
        },
        handleObserver: function () {
            var S = this;
            if (S.maxDom.length) {
                // 判断元素是否进入可视区域
                let lookObserver = new IntersectionObserver(function(entries, observer) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                           S.renderHtml();
                           // 停止观察该元素
                           observer.unobserve(entry.target);
                        }
                    });
                }, {
                    root: null, // 使用视口作为根元素
                    rootMargin: '0px',
                    threshold: 0.1 // 触发回调的阈值，当元素 10% 可见时触发
                });
                lookObserver.observe(S.maxDom[0]);
            }
        },
        renderHtml: function () {
            var S = this;
            // 模拟数据。实际数据是拿商品的元字段
            var mockData = $('.J-look-data').val();
            if (mockData == 'null') {
                $('.product-details-look__block').remove();
                return;
            }
            var AB_KEY = 'AB_CompleteTheLook_TEST'

            // 获取分组
            function getABGroup() {
                var group = localStorage.getItem(AB_KEY)

                if (!group) {
                    group = Math.random() < 0.5 ? 'A' : 'B'
                    localStorage.setItem(AB_KEY, group)
                }

                return group
            }

            var plan = 'A';
            try {
                var lookData = JSON.parse(mockData);
                var status = true;
                if (lookData.published && lookData.published == 2) {
                    status = false;
                    $('.product-details-look__block').remove();
                }
                if (!($.isArray(lookData.planBImageItems) && lookData.planBImageItems.length)) {
                    // 没有配置B方案的情况
                    plan = 'A';
                }
                if (!($.isArray(lookData.leftImageItems) && lookData.leftImageItems.length)) {
                    // 没有配置A方案的情况
                    plan = 'B';
                }
                // 获取当前页面的 URL
                var urlNew = new URL(window.location.href);
                // 获取 URL 上的所有参数
                var paramsNew = new URLSearchParams(urlNew.search);
                // 获取特定参数的值
                var specificParamNew = paramsNew.get('ab_test');
                if (specificParamNew == 'A' || specificParamNew == 'B') {
                    plan = specificParamNew;
                }
                if (plan == 'A' && $.isArray(lookData.leftImageItems) && $.isArray(lookData.rightImageItems) && status) {
                    $('.look-block-b').remove();
                    $('.look-block-a').css('display', 'flex');
                    var leftThumbnail = '';
                    var rightThumbnail = '';
                    S.lookData = lookData;
                    lookData.leftImageItems.forEach((acc, index) => {
                        leftThumbnail += `<div class="look-centent-thumbnail swiper-slide" data-handle="${acc.handle}"><img src="${acc.url}" alt=""></div>`
                    })
                    lookData.rightImageItems.forEach((acc, index) => {
                        rightThumbnail += `<div class="look-thumbnail swiper-slide" data-handle="${acc.handle}"><span class="slide-img ${index == 0 ? 'active-slide-img' : ''}"><strong><img src="${acc.url}" alt=""></strong></span></div>`
                    });
                    S.maxDom.find('.look-block-centent__thumbnail').html(leftThumbnail);
                    S.maxDom.find('.look-right-thumbnail').html(rightThumbnail);
                    // 默认显示第一个数据
                    S.models = lookData.leftImageItems[0].modelImgs;
                    S.maxDom.find('.look-block-left__img').html(`<img importance="auto" data-srcset="${S.models[0]}" class="background lazyload" loading="lazy"><div class="media-loading" data-title="GOELIA">GOELIA</div>`);
                    if (lookData.leftImageItems[0].handle) {
                        S.maxDom.find('.look-addtocarts__top').find('.product-item,[data-open-quick-view-popup]').attr('data-product-handle', lookData.leftImageItems[0].handle);
                    }
                    S.maxDom.find('.look-block-centent__bottoms').html(`<img src="${lookData.rightImageItems[0].url}" alt="">`);
                    S.maxDom.find('.look-addtocarts__bottom a').attr('data-product-handle', lookData.rightImageItems[0].handle);
                    // S.maxDom.find('.tops-addtocarts.product-item').attr('data-product-handle', lookData.leftImageItems[0].handle);
                    if (lookData.leftImageItems.length > 1) {
                        S.productImageGalleryLeft(S.maxDom.find('.look-block-centent__tops'));
                    }
                    S.productImageGallery(S.maxDom.find('.look-right-view'));
                } else if (plan == 'B' && $.isArray(lookData.planBImageItems) && status) {
                    $('.look-block-a').remove();
                    $('.look-block-b').css('display', 'flex');
                    const locale = Shopify.routes.root.replace(/\//g, '').replace('-', '');
                    const promotionTextMap = {
                        default: {
                            badge: 'Tap to explore your perfect match.',
                            title: 'MULTIPLE LOOKS'
                        },
                        zh: {
                            badge: '點擊探索你的理想搭配',
                            title: '多種造型',
                        },
                        de: {
                            badge: 'Tippen, um Looks zu entdecken',
                            title: 'Mehrere Looks'
                        },
                        es: {
                            badge: 'Toca para encontrar tu look',
                            title: 'Múltiples estilos'
                        },
                        fr: {
                            badge: 'Appuyez pour trouver votre look',
                            title: 'Looks multiples'
                        },
                        ja: {
                            badge: 'ご登録ありがとうございます！',
                            title: 'タップしてコーデを探す'
                        }
                    };

                    // 取前两位语言代码
                    const langKey = locale.substring(0, 2);

                    // 获取当前语言文案
                    const promotionText = promotionTextMap[langKey] || promotionTextMap.default;
                    $('.product-details-look .look-block-title').html(promotionText.title);
                    $('.product-details-look .desc').html(promotionText.badge);
                    // 只取前四项
                    var items = lookData.planBImageItems.slice(0, 4);
                    var listHtml = '';
                    items.forEach(acc => {
                        listHtml += `<div class="look-block-left comp-content-image">
                            <div class="look-block-left__img media--loading-effect">
                                <img importance="auto" data-srcset="${acc.url}" class="background lazyload" loading="lazy"><div class="media-loading" data-title="GOELIA">GOELIA</div>
                            </div>
                            <div class="look-addtocarts__block">
                                <div class="look-addtocarts__top look-addtocarts">
                                    <a class="button swiper-slide-new" href="javascript:;" data-handle="${acc.handle}">
                                        <div class='round'></div>
                                        <span>
                                            <img src="https://cdn.shopify.com/s/files/1/0617/0099/7296/files/cart-white.png?v=1773971350" alt="">
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>`;
                    })
                    $('.look-block-b').html(listHtml);
                }
            } catch (err) {}
        },
        productImageGalleryLeft: function (sliderFor) {
            var S = this;
            const swiper = new Swiper(sliderFor[0], {
                slidesPerView: 1,           // 显示数量
                slidesPerGroup: 1,
                spaceBetween: 0,
                loop: true,

                pagination: {
                    el: sliderFor.find('.swiper-pagination')[0],
                    clickable: true
                },
                // 左右箭头
                navigation: {
                    nextEl: sliderFor.find('.swiper-button-next')[0],
                    prevEl: sliderFor.find('.swiper-button-prev')[0]
                },
                on: {
                    slideChange: function () {
                        if (window.gtag) {
                            window.innerWidth < 768 ? gtag('event', 'mixmatch_slide_m') : gtag('event', 'mixmatch_slide_p');
                        }
                        S.models = S.lookData.leftImageItems[this.realIndex].modelImgs;
                        S.maxDom.find('.look-block-left__img').html(`<img importance="auto" data-srcset="${S.models[S.currentIndex]}" class="background lazyload" loading="lazy"><div class="media-loading" data-title="GOELIA">GOELIA</div>`);
                        if (S.lookData.leftImageItems[this.realIndex].handle) {
                            S.maxDom.find('.look-addtocarts__top').find('.product-item,[data-open-quick-view-popup]').attr('data-product-handle', S.lookData.leftImageItems[this.realIndex].handle);
                        }
                    }
                }
            });
        },
        productImageGallery: function (sliderFor) {
            var S = this;
            const swiper = new Swiper(sliderFor[0], {
                direction: window.innerWidth < 768 ? 'horizontal' : 'vertical',      // 纵向
                slidesPerView: 5,           // 显示数量
                slidesPerGroup: 1,
                spaceBetween: window.innerWidth < 768 ? 10 : 20,
                centeredSlides: window.innerWidth >= 768,       // ⭐ 当前项居中
                loop: window.innerWidth >= 768,                 // ⭐ 无限循环
                mousewheel: window.innerWidth >= 768,           // 鼠标滚动
                slideToClickedSlide: window.innerWidth >= 768,

                pagination: {
                    el: sliderFor.find('.swiper-pagination')[0],
                    type: 'progressbar'
                },
                on: {
                    slideChange: function () {
                        if (window.gtag) {
                            window.innerWidth < 768 ? gtag('event', 'mixmatch_slide_m') : gtag('event', 'mixmatch_slide_p');
                        }
                        const slide = this.slides[this.activeIndex];
                        S.currentIndex = this.realIndex;
                        updateSlide(slide, this.realIndex);
                    }
                }
            });
            if (window.innerWidth < 768) {
                $(sliderFor[0]).on('click', '.swiper-slide', function () {
                    const $slide = $(this);
                    if (window.gtag) {
                        gtag('event', 'mixmatch_slide_m');
                    }
                    // 手动控制 active
                    $slide.find('.slide-img').addClass('active-slide-img');
                    $slide.siblings().find('.slide-img').removeClass('active-slide-img');
                    S.currentIndex = $slide.index();
                    updateSlide(this, $slide.index());
                });
            }
            
            // 更新 slide 的函数
            function updateSlide(slide, index) {
                var handle = $(slide).attr('data-handle');
                var src = $(slide).find('img').attr('src');
                S.maxDom.find('.look-block-centent__bottoms').html(`<img src="${src}" alt="">`);
                S.maxDom.find('.look-addtocarts__bottom a').attr('data-product-handle', handle);
                S.maxDom.find('.look-block-left__img').html(`<img importance="auto" data-srcset="${S.models[index]}" class="background lazyload" loading="lazy"><div class="media-loading" data-title="GOELIA">GOELIA</div>`);
            }

        }
    }
    look.init();
})(jQuery);